export const scrollToElement = (elementId: string) =>
  document.getElementById(elementId)?.scrollIntoView();
